<template>
<section class="fancy">
	<div class="container">
		<div class="fancy-box">
			<div class="headline-lg">Settings</div>
			<p>
				Through our Kickstarter campaign you have unlocked additional settings that will be available at launch and will be included in our content subscription.<br />
				Each setting will contain around 600+ assets for regional landmarks, city buildings, biomes and battlemaps.
			</p>
			<div class="setting-section">
				<div class="headline-slim">Fantasy</div>
				<SettingsItem v-bind:settings="settings.fantasy" v-bind:user="user" v-bind:phase="phase" />
			</div>
			<div class="setting-section">
				<div class="headline-slim">Earth based</div>
				<SettingsItem v-bind:settings="settings.earthbased" v-bind:user="user" v-bind:phase="phase" />
			</div>
			<div class="setting-section">
				<div class="headline-slim">SciFi</div>
				<SettingsItem v-bind:settings="settings.scifi" v-bind:user="user" v-bind:phase="phase" />
			</div>
			<div class="legend">
				<div><span class="legend-text">Not included in your order</span> <span class="img-wrapper"><img src="~@/assets/img/img_legende_locked.png" alt=""></span></div>
				<div><span class="legend-text">Included in your content subscription</span> <span class="img-wrapper"><img class="w100" src="~@/assets/img/img_legende_sub.png" alt=""></span></div>
				<div><span class="legend-text">Included in your standalone app</span> <span class="img-wrapper"><img class="w100" src="~@/assets/img/img_legende_included.png" alt=""></span></div>
			</div>
		</div>
	</div>
</section>
</template>

<script>
import SettingsItem from './settings/SettingsItem.vue'

export default {
	name: 'SectionFancySettings',
	components: {
		SettingsItem
	},
	props: {
		user: Object,
		phase: Object,
	},
	data: () => ({
		settings: {
			fantasy,
			earthbased,
			scifi
		}
	}),
}


let fantasy = {
	"setting-base-fantasy": {
		"name": "Base Fantasy",
		"banderole": "included",
		"image": "img_setting_basefantasy.png",
		"text": "<p>The base setting will be included in the <strong>stand-alone version</strong> and will cover a set of base assets to create <em>world-, city-, space-</em> and <em>battle maps</em>.</p><p>The first regional landmark and world assets will be rolled out with <em>ALPHA 1</em>.</p>",
		"download": "https://deios-api.prd.dungeonfog.com/download?file=Caeora_Base_Pack.zip"
	},
	"setting-deadhaus-sonata": {
		"name": "Deadhouse Sonata",
		"banderole": "included",
		"image": "img_setting_deadhaussonata.png",
		"text": "<p>Deadhaus Sonata was brought to you by our MyWorld backers from <strong>Apocalypse Studios</strong> and will also be included in the <strong>stand-alone version</strong>.</p>",
		"download": "https://deios-api.prd.dungeonfog.com/download?file=Caeora_Deadhouse_Pack.zip"
	},
	"setting-underdark": {
		"name": "Underdark",
		"banderole": "",
		"image": "img_setting_underdark.png",
		"text": "<p>Underdark will be available either as part of the <strong>premium content subscription</strong> or a separately <strong>purchasable</strong> setting in our asset store.</p><p>The setting comes with special assets and biomes for <em>underground worlds, caves</em> and <em>below-surface cities</em>.</p>",
		"download": "https://deios-api.prd.dungeonfog.com/download?file=Caeora_Underdark_Pack.zip"
	},
	"setting-high-fantasy": {
		"name": "High Fantasy",
		"banderole": "",
		"image": "img_setting_highfantasy.png",
		"text": "<p>High Fantasy will be available either as part of the <strong>premium content subscription</strong> or as a separately <strong>purchasable</strong> setting in our asset store.</p><p>The setting comes with special assets and biomes for <em>flying islands, high magic landmarks</em> and <em>cities</em>.</p>",
		"download": "https://deios-api.prd.dungeonfog.com/download?file=Caeora_High_Fantasy_Pack.zip"
	}
};

let earthbased = {
	"setting-lost-civilizations": {
		"name": "Lost Civilisations",
		"banderole": "",
		"image": "img_setting_lostciv.png",
		"text": "<p>Lost Civilizations will be available either as part of the <strong>premium content subscription</strong> or as a separately <strong>purchasable</strong> setting in our asset store.</p><p>The setting comes with special assets and biomes for <em>pre-historical nature, ancient landmarks</em> and <em>long forgotten cities</em>.</p>",
		"download": "https://deios-api.prd.dungeonfog.com/download?file=Caeora_Lost_Civ_Pack.zip"
	},
	"setting-wondrous-empires": {
		"name": "Wondorous Empires",
		"banderole": "",
		"image": "img_setting_wondorousempires.png",
		"text": "<p>Wonderous Empires will be available either as part of the <strong>premium content subscription</strong> or as a separately <strong>purchasable</strong> setting in our asset store.</p><p>The setting comes with special assets and biomes for <em>ancient empires, wonderous landmarks</em> and <em>glorious cities</em>.</p>",
		"download": "https://deios-api.prd.dungeonfog.com/download?file=Caeora_Wondrous_Empires_Pack.zip"
	},
	"setting-age-of-exploration": {
		"name": "Age of Exploration",
		"banderole": "",
		"image": "img_setting_age_of_exploration.png",
		"text": "<p>Age of Exploration will be available either as part of the <strong>premium content subscription</strong> or as a separately <strong>purchasable</strong> setting in our asset store.</p><p>The setting comes with special assets and biomes for <em>unexplored lands, mysterious landmarks</em> and <em>renaissance cities</em>.</p>",
		"download": "https://deios-api.prd.dungeonfog.com/download?file=Caeora_Age_of_Sail_Pack.zip"
	}
};

let scifi = {
	"setting-solar-systems-and-galaxies": {
		"name": "Solar Sytems and Galaxies",
		"banderole": "",
		"image": "img_setting_solar_systems_and_galaxies.png",
		"text": "<p>Solar Sytems and Galaxies will be available either as part of the <strong>premium content subscription<strong> or as a separately <strong>purchasable</strong> setting in our asset store.</p><p>The setting comes with special assets and biomes for <em>solar systems, astronomical objects</em> and <em>galaxies</em>.</p>",
		"download": null
	},
	"setting-cyberpunk": {
		"name": "Cyberpunk",
		"banderole": "",
		"image": "img_setting_cyberpunk.png",
		"text": "<p>Cyberpunk will be available either as part of the <strong>premium content subscription</strong> or as a separately <strong>purchasable</strong> setting in our asset store.</p><p>The setting comes with special assets and biomes for <em>high-tech worlds, cyberspace</em> and <em>mega-cities</em>.</p>",
		"download": "https://deios-api.prd.dungeonfog.com/download?file=Caeora_Cyberpunk_Pack.zip"
	},
	"setting-space-travel": {
		"name": "Space Travel",
		"banderole": "",
		"image": "img_setting_spacetravel.png",
		"text": "<p>Space Travel will be available either as part of the <strong>premium content subscription</strong> or as a separately <strong>purchasable</strong> setting in our asset store.</p><p>The setting comes with special assets and biomes for <em>strange alien worlds, star bases</em> and <em>planetar outposts</em>.</p>",
		"download": "https://deios-api.prd.dungeonfog.com/download?file=Caeora_Space_Travel_Pack.zip"
	}
};
// Test
</script>
